const projects = [
  {
    id: 1,
    name: "Photography Portfolio",
    href: "https://photography-portfolio-psi-ruby.vercel.app",
    imageSrc:
      "/photog5.jpg",

    used: "ReactJS",
    description: "A personal photography website capturing my experiences and hobbies.",
  },
  {
    id: 2,
    name: "Stress: The Card Game",
    href: "https://github.com/petercegoh/card-game-stress",
    imageSrc:
      "/stress.png",
    used: "Java AWT, Java Swing, Object-Oriented Programming",
    description: "An interactive single or multiplayer experience where time is of the essence!",
  },
  {
    id: 3,
    name: "MatchMage",
    href: "https://github.com/petercegoh/cs203-MatchMage",
    imageSrc:
      "/mage2.png",
    used: "Flask, Spring Boot, Mockito, Firebase, GitLab, Docker",
    description: "A tournament management system solution created for Magic: The Gathering (MTG). Built with GitLab, Docker, ECR, EKS, EC2",
  },

  {
    id: 4,
    name: "Jam Oracle",
    href: "https://github.com/petercegoh/jam-oracle",
    imageSrc:
      "/jam_oracle.png",
    used: "ReactJS, TailwindCSS, Flask, Google Cloud",
    description: "A traffic visualisation tool",
  },
    {
    id: 5,
    name: "OverClocked",
    href: "https://github.com/ianpuajc/CS205Game",
    imageSrc:
      "/overclocked.png",
    used: "LibGDX, AndroidStudio",
    description: "Android Mobile Game",
  },
    {
    id: 6,
    name: "AggreRate",
    //href: "https://github.com/petercegoh/jam-oracle",
    imageSrc:
      "/aggrerate.png",
    used: "OpenAI API",
    description: "Review Sentiment Summariser",
  },

];

export default function Projects() {
  return (
    <div id="projects">
      <div className="mx-auto max-w-2xl px-6 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:px-8">
        <h2 className="text-lg leading-7 text-center">Browse my recent</h2>
        <p className="mt-2 text-4xl font-bold tracking-tight sm:text-6xl text-center">
          Projects
        </p>
        <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="group relative ring-2 ring-base-300 bg-base-200 rounded-2xl shadow-xl"
              data-aos="flip-left"
            >
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md lg:aspect-none group-hover:brightness-75 duration-300 delay-100 lg:h-80 rounded-t-2xl ">
                <img
                  src={project.imageSrc}
                  alt={project.name}
                  className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between p-4">
                <div className="p-4">
                  <h3 className="text-lg font-bold">
                    <a href={project.href}>
                      <span aria-hidden="true" className="absolute inset-0" />
                      {project.name}
                    </a>
                  </h3>
                  <p className="mt-1 mb-5 text-sm">{project.description}</p>
                  <p className="text-sm font-medium">{project.used}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

//put this in the gap when you want "view more"

//<div className="mt-16 flex justify-center">
//<button className="btn btn-outline">View More</button>
//</div>
